module.exports = {
          srcSet: __webpack_public_path__ + "public/images/687fb01abf88895a9f7e560bd52eda93-1774.webp"+" 1774w",
          images:[ {path: __webpack_public_path__ + "public/images/687fb01abf88895a9f7e560bd52eda93-1774.webp",width: 1774,height: 887}],
          src: __webpack_public_path__ + "public/images/687fb01abf88895a9f7e560bd52eda93-1774.webp",
          toString:function(){return __webpack_public_path__ + "public/images/687fb01abf88895a9f7e560bd52eda93-1774.webp"},
          
          width: 1774,
          height: 887
        }